<template lang="pug">
  div
    SubHeader
    br
    v-container
      v-row
        v-col(v-for='(service, i) in services', cols='12', md='4', :key='i')
          Informarion(:title='service.title', :text='service.text')
    br
</template>

<script>
// ~ is an alias to /src
import SubHeader from '@/components/SubHeader.vue'
import Informarion from '@/components/Information.vue'

export default {
  name: 'Index',
  components: {
    SubHeader,
    Informarion
  },
  data() {
    return {
      services: [
        {icon: null, title: 'CHIP ID', text: 'Es un sistema de identificación subcutáneo, este chip viene en un completo sistema higiénico y desechable, cumpliendo con las normas internacionales y certificaciones ISO 11784-11785 de identificación animal.'},
        {icon: 'fa-user', title: 'PET TAG', text: 'El Pet Tag, es una placa de identificación interactiva, la cual permite brindar la información básica del propietario en el momento de ser escaneado.'},
        {icon: null, title: 'PET COLLAR', text: 'Es un Sistema de identificación, tipo collar, la cual permite brindar la información básica del propietario en el momento de ser escaneado.'}
      ]
    }
  },
}
</script>

